import { CountryCode } from '@dayetopia/types';
import * as Yup from 'yup';
import 'yup-phone-lite';

const countries = Object.values(CountryCode);

const createBaseAddressValidationSchema = (t: (key: string, params?: object) => string) =>
  Yup.object({
    firstName: Yup.string()
      .label(t('components.first-name'))
      .required(t('address-error.firstname-required'))
      .max(24, ({ label }) => t('address-error.max-length', { label, max: 24 })),
    lastName: Yup.string()
      .label(t('components.last-name'))
      .required(t('address-error.lastname-required'))
      .max(24, ({ label }) => t('address-error.max-length', { label, max: 24 })),
    street1: Yup.string()
      .label(t('components.address-1'))
      .required(t('address-error.street1-required'))
      .max(40, ({ label }) => t('address-error.max-length', { label, max: 40 })),
    street2: Yup.string()
      .label(t('components.address-2'))
      .nullable()
      .max(40, ({ label }) => t('address-error.max-length', { label, max: 40 })),
    city: Yup.string()
      .label(t('components.city'))
      .required(t('address-error.city-required'))
      .max(30, ({ label }) => t('address-error.max-length', { label, max: 30 })),
    state: Yup.string()
      .label(t('components.state'))
      .nullable()
      .max(30, ({ label }) => t('address-error.max-length', { label, max: 30 })),
    postalCode: Yup.string()
      .label(t('components.postcode-zip'))
      .required(t('address-error.postal-code-required'))
      .max(20, ({ label }) => t('address-error.max-length', { label, max: 20 })),
    country: Yup.string()
      .label(t('components.country'))
      .required(t('address-error.country-required'))
      .oneOf(Object.values(CountryCode), t('address-error.invalid-country-code'))
  });

interface ValidationOptions {
  includePhoneNumber?: boolean;
}

const getDeliveryValidationSchema = (t: (key: string, params?: object) => string, options: ValidationOptions = { includePhoneNumber: false }) => {
  let schema = createBaseAddressValidationSchema(t);

  if (options.includePhoneNumber) {
    schema = schema.shape({
      phone: Yup.string()
        .label(t('components.phone'))
        .phone(countries, t('address-error.valid-phone-number'))
        .required(t('address-error.phone-number-required'))
    });
  }

  return schema;
};

const getBillingValidationSchema = (t: (key: string, params?: object) => string) => createBaseAddressValidationSchema(t).shape({});

export { getDeliveryValidationSchema, getBillingValidationSchema };
